import Environment from "@shared/environment";
import LoggerService from "@shared/services/logger.service";
import ToasterService from "@shared/services/toaster.service";
import axios from "axios";
var HttpClient = /** @class */ (function () {
    function HttpClient() {
        // this.axiosInstance.interceptors.request.use(config => {
        //   NProgress.start();
        //   return config;
        // });
        this.toasterService = new ToasterService();
        this.logger = new LoggerService();
        this.axiosInstance = axios.create();
        // this.axiosInstance.interceptors.response.use(response => {
        //   NProgress.done();
        //   return response;
        // });
    }
    HttpClient.prototype.get = function (url) {
        this.logger.debug("HttpClient GET: " + url);
        return this.axiosInstance.get(url);
    };
    HttpClient.prototype.post = function (url, body) {
        this.logger.debug("HttpClient POST data: " + url);
        return this.axiosInstance.post(url, body);
    };
    HttpClient.prototype.put = function (url) {
        this.logger.debug("HttpClient PUT: " + url);
        return this.axiosInstance.put(url);
    };
    HttpClient.prototype.putAsJson = function (url, object) {
        var json = JSON.stringify(object);
        this.logger.debug("HttpClient PUT: " + url + " \nJson: " + json);
        return this.axiosInstance.put(url, json, this.getJsonRequestConfig());
    };
    HttpClient.prototype.postAsJson = function (url, object) {
        var json = JSON.stringify(object);
        this.logger.debug("HttpClient POST: " + url + " \nJson: " + json);
        return this.axiosInstance.post(url, json, this.getJsonRequestConfig());
    };
    HttpClient.prototype.delete = function (url) {
        this.logger.debug("HttpClient DELETE: " + url);
        return this.axiosInstance.delete(url);
    };
    HttpClient.prototype.defaultErrorHandler = function (reject, error) {
        var serverMessage = error.response && error.response.data.message;
        var errorMessage = serverMessage || error.message || "";
        if (errorMessage.length === 0) {
            errorMessage = "Ooops, something went wrong...";
        }
        if (!Environment.production) {
            if (error.response && error.response.data) {
                this.logger.error("An error occurred", error.response.data);
            }
            else {
                this.logger.error("An error occurred", error);
            }
        }
        this.toasterService.showErrorMessage(errorMessage);
        reject(error);
    };
    HttpClient.prototype.getJsonRequestConfig = function () {
        var axiosConfig = {
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
            }
        };
        return axiosConfig;
    };
    return HttpClient;
}());
export default HttpClient;



//////////////////
// WEBPACK FOOTER
// ./app/shared/services/http-client.service.ts
// module id = 15
// module chunks = 0 1 2 3 4 5